var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDetach = function SvgDetach(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2869 23.3033L22.4175 23.3033L22.4109 15.8986L14.3432 23.9662L13.0174 22.6404L21.085 14.5727L13.6803 14.5794L13.6803 12.6967H24.2869V23.3033Z",
    fill: "#8B90A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9857 6H9.98572C8.33572 6 6.98572 7.35 6.98572 9V27C6.98572 28.65 8.33572 30 9.98572 30H27.9857C29.6357 30 30.9857 28.65 30.9857 27V9C30.9857 7.35 29.6357 6 27.9857 6ZM27.9857 27H9.98572V9H27.9857V27Z",
    fill: "#8B90A0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDetach);
export { ForwardRef as ReactComponent };